import localization from '../../../../shared/strings';

const l10n = localization.PRODUCT_INFO.seo;

export function buildSeoFallbackTooltip({ value, field, fallbackValue }) {
  const charCount = String(value ?? '').length;
  if (charCount || !fallbackValue) return null;
  return field === 'title'
    ? l10n.titleFallbackHint(fallbackValue)
    : l10n.descriptionFallbackHint(fallbackValue);
}

export function buildSeoFieldHelperText({
  value,
  recommendedMax,
  field,
}) {
  const charCount = String(value ?? '').length;
  const counter = l10n.characterCounter(charCount, recommendedMax);
  const parts = [counter];

  if (charCount > recommendedMax) {
    parts.push(field === 'title' ? l10n.titleLengthExceeded : l10n.descriptionLengthExceeded);
  }

  return parts.join('\n');
}
